var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getTrackingData = function (item, list, position) { return ({
    list: list,
    product: {
        id: item.uuid,
        name: item.title,
        category: item.type,
        position: position,
    },
}); };
export var addTrackingData = function (item, list, position) { return (__assign(__assign({}, item), { trackingData: {
        list: list,
        product: {
            id: item.uuid,
            name: item.title,
            category: item.type,
            position: position,
        },
    } })); };
